module.exports = __webpack_public_path__ + "static/img/user.86b482a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 1445
// module chunks = 4